import { useEffect, useState } from 'react'

import type { CloudAPI } from 'lib/cloud-sync/cloud-api'
import { listProjects } from 'lib/cloud-sync/cloud-api'
import { getOAuthToken } from './cloud-api-auth'

type Status = 'idle' | 'loading' | 'succeeded' | 'failed'

type UseListProjectsResult = {
  status: Status
  error: Error | null
  response: CloudAPI.ProjectInfoResponse[] | null
}

const useListProjects = (): UseListProjectsResult => {
  const [status, setStatus] = useState<Status>('idle')
  const [error, setError] = useState<Error | null>(null)
  const [response, setResponse] = useState<
    CloudAPI.ProjectInfoResponse[] | null
  >(null)

  useEffect(() => {
    ;(async () => {
      setStatus('loading')
      try {
        // get token
        const token = getOAuthToken()
        if (!token) {
          setError(new Error('User is not authenticated'))
          setStatus('failed')
          return
        }

        // perform call
        const res = await listProjects(token)

        // success
        setResponse(res)
        setStatus('succeeded')
      } catch (anError) {
        // failure
        setError(anError as Error)
        setStatus('failed')
      }
    })()
  }, [])

  return {
    status,
    error,
    response,
  }
}

export default useListProjects
